import { useContext } from "react"
import styled from "styled-components"
import TagsList from "components/car/TagsList"
import { mq } from "helpers/styled"
import Promotions from "components/car/Promotions"
import { PromoWrapper } from "components/car/Promotions/PromoContainer"
import { CarContext } from "../CarContext"

const Wrapper = styled.div`
  position: absolute;
  top: 15px;
  left: -15px;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  z-index: 1;

  ${({ mediaActive }) => mediaActive && `opacity: 0`};

  @media ${mq("md")} {
    left: 15px;
  }

  @media ${mq("lg")} {
    overflow: hidden;
  }

  ${PromoWrapper} {
    padding-right: 10px;
    left: var(--container-padding);

    @media ${mq("lg")} {
      left: auto;
    }
  }
`

function TagsAndPromos() {
  const { car, showMedia } = useContext(CarContext)

  return (
    <Wrapper mediaActive={showMedia === "panorama"}>
      <TagsList noFastDelivering reverse {...car} />
      <Promotions car={car} hideOnlineScoring />
    </Wrapper>
  )
}

export default TagsAndPromos
